import React, { useEffect, useState } from "react";
import "./GroupLoansMemberContributions.scss";
import { useSelector, useDispatch } from "react-redux";
import { Box, Button, Menu, MenuItem, Typography, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { commonRunQuery, listTransactionHistory5 } from "../../../util/API/loans";
import GroupLoansTable from "../../../components/GroupLoansTable/GroupLoansTable";
import CloseIcon from "@mui/icons-material/Close";
import BaseDrawer from "../../../components/UI/BaseDrawer/BaseDrawer";

const GroupLoansMemberContributions = ({ selectedBalance, setBalancesListView, selectedMemberName }) => {
    const [memberContributions, setMemberContributions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedContribution, setSelectedContribution] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);

    useEffect(()=>{
        console.log("selectedBalance------------",selectedBalance?.vloangroupmemberuserpi);
        getMemberContributions();
    },[selectedBalance]);

    const columns = [
        {
            label: 'TXN Id',
            getValue: (row) => row?.Vtranshistory?.transID ?? ''
        },
        {
            label: 'TXN Time',
            getValue: (row) => row?.Vtranshistory?.transTime ?? ''
        },
        {
            label: 'TXN Type',
            getValue: (row) => row?.Vtranshistory?.transtypelabel ?? ''
        },
        {
            label: 'Product Code',
            getValue: (row) => row?.Vtranshistory?.currID ?? ''
        },
        {
            label: 'Amount',
            getValue: (row) => row?.Vtranshistory?.amount ?? ''
        },
        {
            label: 'Merchant Name',
            getValue: (row) => row?.Vtranshistory?.merchant_name ?? ''
        }
    ];

    const getMemberContributions = async() => {
        try {
            const response = await listTransactionHistory5("", selectedBalance?.vloangroupmemberuserpi?.acctID, selectedBalance?.vloangroupmemberuserpi?.currCode, "EN", 0, "", "", "" );
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const groupsArray = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
      
                setMemberContributions(groupsArray);
              console.log("getMemberContributions_response==========",groupsArray);
            } else {
                setMemberContributions([]);
            }
      
        } catch (error) {
            console.log("getMemberContributions_error==========",error);
        } finally {
            setLoading(false)
        }
    }

    const handleMenuOpen = (event, loan) => {
        console.log("GroupLoansMemberBalances_handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedContribution(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    return (
        <Box>
            <Box className="d-flex justify-content-between">
                <Typography
                sx={{
                    fontFamily: "'Nunito'",
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "21.4825px",
                    color: "#3A3A3A",
                }}
                className=""
                >
                    Member Contributions - {selectedMemberName}
                </Typography>

                <Button
                    className="fs-size-12 paiy-blue text-white"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        setBalancesListView(null);
                    }}
                >
                    Return
                </Button>
            </Box>

            <Box className="mt-4">
                <GroupLoansTable
                    data={memberContributions} 
                    columns={columns} 
                    title="Member Contributions" 
                    formatRow={(row) => [
                        row.id,
                        row.record?.BorrowerName,
                        row.name,
                        row.balance,
                        row.record?.DaysPastDue,
                        row.record?.AmountDue
                    ]} 
                    viewMenu={true}
                    handleMenuOpen={handleMenuOpen}
                    downloads={false}
                    // author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
                />
            </Box>

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem
                    onClick={() => {
                        // setOpenDetailsDialog(true);
                        setOpenDetailsDrawer(true);
                        handleMenuClose();
                    }}
                >
                    View Details
                </MenuItem>
            </Menu>

            <BaseDrawer
                open={openDetailsDrawer}
                handleClose={() => setOpenDetailsDrawer(false)}
                height="70vh"
                className="loanProductInfoDrawer"
                overflow="auto"
            >
                {selectedContribution && (
                    <Box>
                        <Box className="user-accounts-tab">
                            <Box className="balance-container">
                                <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                    {/* Left Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[
                                            { label: "Amount", value: selectedContribution?.Vtranshistory?.amount || "N/A" },
                                            { label: "Classification", value: selectedContribution?.Vtranshistory?.classification || "N/A" },
                                            { label: "Curr Id", value: selectedContribution?.Vtranshistory?.currID || "-" },
                                            { label: "Destination Node Id", value: selectedContribution?.Vtranshistory?.destinationNodeID || "N/A" },
                                            { label: "Destination User Id", value: selectedContribution?.Vtranshistory?.destinationUserID || "N/A" },
                                            { label: "Merchant Name", value: selectedContribution?.Vtranshistory?.merchant_name || "-" },
                                            { label: "Message", value: selectedContribution?.Vtranshistory?.msg || "-" },
                                            { label: "Time Abbreviation", value: selectedContribution?.Vtranshistory?.timeabbreviation || "N/A" },
                                        ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">{value}</Box>
                                            </Box>
                                        ))}
                                    </Box>

                                    {/* Right Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[
                                            { label: "Control Account", value: selectedContribution?.Vtranshistory?.transID || "-" },
                                            { label: "Trans Id", value: selectedContribution?.Vtranshistory?.transLineID || "N/A" },
                                            { label: "Trans Time", value: selectedContribution?.Vtranshistory?.transTime || "N/A" },
                                            { label: "Trans Type", value: selectedContribution?.Vtranshistory?.transType || "N/A" },
                                            { label: "Trans Type Label", value: selectedContribution?.Vtranshistory?.transtypelabel || "N/A" },
                                            { label: "Reference TXID", value: selectedContribution?.Vtranshistory?.referenceTXID || "-" },
                                            { label: "Source Node Id", value: selectedContribution?.Vtranshistory?.sourceNodeID || "-" },
                                            { label: "Source User Id", value: selectedContribution?.Vtranshistory?.sourceUserID || "-" },
                                        ].filter(Boolean).map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">{value}</Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )}
            </BaseDrawer>

            {/* <Dialog
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}
                fullWidth
                maxWidth="md"
                className="loans-dialog"
            >
                <DialogTitle>
                    <Box>
                        Member Balance Details
                        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                            <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedContribution && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                        <Box minWidth="300px" flex={1}>
                                            {[
                                                { label: "Amount", value: selectedContribution?.Vtranshistory?.amount || "N/A" },
                                                { label: "Classification", value: selectedContribution?.Vtranshistory?.classification || "N/A" },
                                                { label: "Curr Id", value: selectedContribution?.Vtranshistory?.currID || "-" },
                                                { label: "Destination Node Id", value: selectedContribution?.Vtranshistory?.destinationNodeID || "N/A" },
                                                { label: "Destination User Id", value: selectedContribution?.Vtranshistory?.destinationUserID || "N/A" },
                                                { label: "Merchant Name", value: selectedContribution?.Vtranshistory?.merchant_name || "-" },
                                                { label: "Message", value: selectedContribution?.Vtranshistory?.msg || "-" },
                                                { label: "Time Abbreviation", value: selectedContribution?.Vtranshistory?.timeabbreviation || "N/A" },
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value}</Box>
                                                </Box>
                                            ))}
                                        </Box>

                                        <Box minWidth="300px" flex={1}>
                                            {[
                                                { label: "Control Account", value: selectedContribution?.Vtranshistory?.transID || "-" },
                                                { label: "Trans Id", value: selectedContribution?.Vtranshistory?.transLineID || "N/A" },
                                                { label: "Trans Time", value: selectedContribution?.Vtranshistory?.transTime || "N/A" },
                                                { label: "Trans Type", value: selectedContribution?.Vtranshistory?.transType || "N/A" },
                                                { label: "Trans Type Label", value: selectedContribution?.Vtranshistory?.transtypelabel || "N/A" },
                                                { label: "Reference TXID", value: selectedContribution?.Vtranshistory?.referenceTXID || "-" },
                                                { label: "Source Node Id", value: selectedContribution?.Vtranshistory?.sourceNodeID || "-" },
                                                { label: "Source User Id", value: selectedContribution?.Vtranshistory?.sourceUserID || "-" },
                                            ].filter(Boolean).map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value}</Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                            Close
                        </Button>
                    </DialogActions>
            </Dialog> */}
        </Box>
    )
}

export default GroupLoansMemberContributions;
